import {
    Summary,
    betSummarySliceActions,
} from '@/modules/report/slice/betSummary';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import moment from 'moment';
import { CMDSpBetRecordSummaryQuery, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpBetRecordSummaryQueryHandler extends AbstractHandler {
    _command: CMDSpBetRecordSummaryQuery;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpBetRecordSummaryQuery;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const summaries: Summary[] = [];

        for (let b of this._command.Bet) {
            const summary = {} as Summary;
            summary.GameID = b.GameID;
            const gameCount = b.GameCount;
            summary.GameCount = gameCount;
            summary.Shoes = Math.floor(gameCount / 10000);
            summary.Round = gameCount % 10000;
            summary.GameType = b.GameType;
            summary.HostID = b.HostID;
            const m = moment.unix(b.ReportTime).utc(false);
            summary.ReportDate =
                m.format('yyyy-MM-DD') + ' ' + m.format('HH:mm:ss');
            summary.ResultAmount = b.ResultAmount;
            summary.RollingAmount = b.RollingAmount;
            summary.BetAmount = b.BetAmount;
            summary.WinSlot = b.WinSlot;
            summary.Result = b.Result;
            summary.State = b.State;
            summaries.push(summary);
        }

        dispatch(
            betSummarySliceActions.updateSummary({
                summaries: summaries,
            })
        );
    }
}
